var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainmenuPwdExpiryReminder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61,
    height: 32,
    viewBox: "0 0 61 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7440",
    "data-name": "Rectangle 7440",
    width: 39.349,
    height: 19.316,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22334",
    "data-name": "Group 22334",
    transform: "translate(-1635 -11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7438",
    "data-name": "Rectangle 7438",
    width: 61,
    height: 32,
    rx: 4,
    transform: "translate(1635 11)",
    fill: "#e13f3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22333",
    "data-name": "Group 22333",
    transform: "translate(1647.191 17.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22332",
    "data-name": "Group 22332",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13166",
    "data-name": "Path 13166",
    d: "M20.158,20.139c.642-.168,1.341-1,1.848-.046.457.863-.5,1.039-.983,1.467.376.509,1.558.664.931,1.617-.527.8-1.154.062-1.776-.15-.231.6.232,1.639-.863,1.622-1.048-.017-.628-.992-.815-1.61-.64.161-1.334,1.013-1.845.052-.459-.862.484-1.046.979-1.469-.36-.516-1.556-.659-.93-1.615.531-.811,1.154-.05,1.784.126.224-.578-.239-1.621.855-1.605,1.049.016.628.992.814,1.611",
    transform: "translate(-12.324 -13.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13167",
    "data-name": "Path 13167",
    d: "M51.571,21.587c.593.453,1.534.69,1.011,1.565-.49.82-1.145.134-1.765-.125-.217.628.171,1.7-.955,1.617-.974-.07-.59-.99-.752-1.594-.619.116-1.3,1.008-1.833.056-.5-.906.53-1.054,1-1.52-.442-.458-1.535-.614-.982-1.541.522-.873,1.182-.093,1.8.1.193-.626-.217-1.643.874-1.618.983.022.677.932.811,1.572.629-.094,1.367-1,1.852.027.4.842-.526,1.036-1.06,1.459",
    transform: "translate(-35.153 -13.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13168",
    "data-name": "Path 13168",
    d: "M81.369,20.163c.661-.2,1.353-1.019,1.859-.041.455.879-.534,1.015-1,1.46.387.492,1.568.634.948,1.6-.547.851-1.192-.012-1.807-.12-.144.627.231,1.588-.816,1.6s-.7-.957-.848-1.584c-.63.12-1.329,1-1.833.024-.44-.85.469-1.061,1-1.46-.413-.5-1.561-.683-.948-1.625.516-.794,1.157-.073,1.755.149.2-.642-.176-1.662.913-1.617.987.041.651.947.776,1.62",
    transform: "translate(-57.98 -13.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13169",
    "data-name": "Path 13169",
    d: "M92.9,26.844a3.046,3.046,0,0,0,3.364-2.633.988.988,0,0,1-.129-.481v-4.2a.988.988,0,0,1,.195-.586q0-1.894,0-3.788a2.113,2.113,0,0,0-1.157.953l-.415.718q0,3.256,0,6.512c0,1.439-.536,1.968-1.991,1.968h-2.9l-.887,1.537c.695,0,1.428,0,3.925-.005",
    transform: "translate(-66.347 -11.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13170",
    "data-name": "Path 13170",
    d: "M21.2,15.46l.838-1.452c-6.753,0-10.01,0-18.442,0-1.512,0-2.025-.509-2.027-2.007q0-4.266,0-8.532c0-1.4.539-1.93,1.954-1.932q7.584-.006,15.167,0h7.575c1.54,0,2.063.416,2.129,1.8a3.357,3.357,0,0,1,1.494-.778C29.585.906,28.419.005,26.512,0,16.373,0,13.609,0,3.47,0A3.136,3.136,0,0,0,0,3.486Q0,7.68,0,11.874c0,2.487,1.171,3.665,3.65,3.667q7.477,0,14.953,0H21.16c.015-.028.029-.056.045-.083",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13171",
    "data-name": "Path 13171",
    d: "M97.1,15.76a2.147,2.147,0,0,0-3.719,0L86.867,27.047a2.147,2.147,0,0,0,1.86,3.221H101.76a2.147,2.147,0,0,0,1.859-3.221Zm-2.757,3.421a1,1,0,0,1,1.99,0v4.2a1,1,0,0,1-1.99,0Zm2.149,7.433a1,1,0,0,1-1,1h-.158a1,1,0,0,1-1-1v-.158a1,1,0,0,1,1-1H95.5a1,1,0,0,1,1,1Z",
    transform: "translate(-64.562 -10.952)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainmenuPwdExpiryReminder);
export default __webpack_public_path__ + "static/media/Mainmenu-pwd-expiry-reminder.2ff110d2d83dcde666a1d42387e24e9f.svg";
export { ForwardRef as ReactComponent };